/**
 * 소명 페이지 SMS 본인 인증 — Defense.js _spaInit 에서 분리 (Phase2-C).
 *   makeAuth({ S, boot, go, stateToScreen, rAuthFormInner })
 *     → { authSuccessGo, bindAuthHandlers, openAuthSheet }
 *
 * full 화면(auth_return)·바텀시트(소명/정정 진입) 공용. 함수 본문은 Defense.js 원본과 동일(동작 보존).
 *   go/stateToScreen/rAuthFormInner/S/boot 는 주입, showToast/showLoading/showOv 는 UiHelpers, phoneNumber 는 전역.
 */
import { showToast, showLoading, showOv } from './UiHelpers';
import Util from '../../../Common/Util';

export function makeAuth({ S, boot, go, stateToScreen, rAuthFormInner, openCallSheet }) {

    // 인증 성공 후 이동: 제보자와 통화(S.afterAuth='call') > 서버 상태(진행/결과) > 정정 요청서
    function authSuccessGo() {
        if (S.afterAuth === 'call') {
            // ① 소명 — 인증 뒤 안내 화면을 다시 그리고 통화 시트를 연다(정정 요청서로 가지 않는다)
            S.afterAuth = 'notme';
            go('auth_first');
            if (typeof openCallSheet === 'function') openCallSheet();
            return;
        }
        const t = boot.state ? stateToScreen(boot.state) : 'auth_first';
        if (t !== 'auth_first' && t !== 'notme') {
            go(t);   // 제출 후 진행/결과 화면 (재접속 확인)
        } else {
            S.skipAgree = false;
            go('notme');
        }
    }

    // 인증 폼 이벤트 바인딩 — 폼이 full 화면이든 바텀시트든 동일(#auth-* ID는 화면에 1개만 존재).
    //   onSuccess: 인증코드 검증 통과 후 호출(화면 이동 또는 BS 닫고 이동).
    function bindAuthHandlers(onSuccess) {
        $('#auth-phone').on('input', function () {
            // 입력 중 자동 대시 포맷팅(010-1234-5678). 상태(S.authPhone)는 숫자만 유지(전송·검증용).
            this.value = Util.phoneNumber(this.value);
            S.authPhone = this.value.replace(/[^0-9]/g, '');
            // 번호를 다시 고치면 이전 안내(불일치/발송완료) → 기본 안내로 복귀
            $('#auth-phone-msg').text('※ 문자를 받으신 본인 명의의 휴대폰 번호를 입력해 주세요.').css('color', 'var(--t3)');
        });
        $('#send-auth-code').on('click', function () {
            const ph = (S.authPhone || '').trim();
            // 010 + 숫자 8개만 받는다. 011·016·017·018·019 는 2G 종료(2021-06)로 전부 010 으로 전환돼 쓰이는 번호가 없고,
            // 제보 화면도 연락처를 010 으로만 받으므로(Report.js) 등록 연락처와 일치할 수 없다.
            // 막힌 이유를 그대로 말해 준다 — 예전엔 019-xxxx-xxxx(11자리)를 넣어도 "11자리를 입력" 이라고만 떴다(2026-09-17).
            if (!/^010[0-9]{8}$/.test(ph)) {
                showToast(ph.length === 11
                    ? '010 으로 시작하는 휴대폰 번호를 입력해주세요'
                    : '휴대폰 번호 11자리를 입력해주세요');
                $('#auth-phone').focus();
                return;
            }
            // 등록 연락처로 6자리 인증코드 알림톡 발송 (서버가 번호 일치 검증)
            const $btn = $(this).prop('disabled', true);
            $.ajax({ url: '/b/defense/ajax/auth/sms/send', type: 'POST', data: { phone: ph }, dataType: 'json' })
                .done((res) => {
                    if (!res || !res.result) {
                        const m = (res && res.message) || '인증번호 발송에 실패했습니다.';
                        showToast(m);
                        // 인라인 안내: 등록 번호와 불일치 등 → 입력칸 아래 빨강
                        $('#auth-phone-msg').text(m).css('color', 'var(--R)');
                        $btn.prop('disabled', false);
                        return;
                    }
                    S.authSent = true;
                    $('#auth-code-area').slideDown(200);
                    $('#auth-phone').prop('disabled', true);
                    $btn.prop('disabled', false).text('재발송').css({ background: 'var(--sf2)', color: 'var(--t2)' });
                    $('#auth-confirm').prop('disabled', false).css({ background: 'var(--grad)', cursor: 'pointer' });
                    showToast('인증번호가 발송되었습니다');
                    // 인라인 안내: 등록 번호 일치 → 발송 완료 (초록)
                    $('#auth-phone-msg').html('✓ 등록된 번호가 맞아요. 인증번호를 발송했어요.').css('color', 'var(--C)');
                    // dev 전용: 알림톡 미발송 환경 — 응답의 인증코드를 화면에 표시(운영에선 dev_code 없음)
                    if (res.dev_code) {
                        $('#auth-msg').html(`<b style="color:var(--R)">[개발] 인증번호: ${res.dev_code}</b>`);
                    } else {
                        $('#auth-msg').text('문자로 받은 인증번호 6자리를 입력해 주세요.').css('color', 'var(--t3)');
                    }
                    // 3분 타이머 (서버 AUTH_TTL=180초와 동일)
                    if (window._authTimer) clearInterval(window._authTimer);
                    let sec = 180;
                    const tick = () => {
                        const m = Math.floor(sec / 60), ss = sec % 60;
                        $('#auth-timer').text(`${m}:${String(ss).padStart(2, '0')}`);
                        if (sec <= 0) {
                            clearInterval(window._authTimer);
                            $('#auth-msg').text('인증번호가 만료되었습니다. 재발송해 주세요.').css('color', 'var(--R)');
                        }
                        sec--;
                    };
                    tick();
                    window._authTimer = setInterval(tick, 1000);
                    setTimeout(() => $('#auth-code').focus(), 300);
                })
                .fail((xhr) => {
                    // 429 = 서버 속도 제한(routes/devil.php throttle) — '오류'가 아니라 잠시 기다리라고 말한다
                    showToast(xhr && xhr.status === 429 ? '요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요.' : '인증번호 발송 중 오류가 발생했습니다.');
                    $btn.prop('disabled', false);
                });
        });
        $('#auth-code').on('input', function () {
            S.authCode = $(this).val().replace(/[^0-9]/g, '').slice(0, 6);
            $(this).val(S.authCode);
        });
        $('#auth-confirm').on('click', function () {
            if (!S.authSent) { showToast('인증번호 발송 후 확인해 주세요'); return; }
            if (!/^[0-9]{6}$/.test(S.authCode)) { showToast('인증번호 6자리를 입력해주세요'); $('#auth-code').focus(); return; }
            // 서버 세션 인증코드와 대조 — 일치 시 SESS_VERIFIED 통과
            const ov = showLoading('인증 확인 중...');
            $.ajax({ url: '/b/defense/ajax/auth/sms/verify', type: 'POST', data: { code: S.authCode }, dataType: 'json' })
                .done((res) => {
                    if (!res || !res.result) {
                        ov.remove();
                        showToast((res && res.message) || '인증번호가 일치하지 않습니다');
                        return;
                    }
                    if (window._authTimer) clearInterval(window._authTimer);
                    S.authVerified = true;
                    S.authVerifiedAt = Date.now();
                    S.smsOk = true;   // 서버 SESS_SMS_OK 와 동기 — 이후 통화·정정 진입은 인증 시트 생략
                    if (res.co_name) S.report.co = res.co_name;   // 인증 완료 → 업체명 원본 노출(E). 제보자 증빙사진은 인증 뒤에도 안 온다
                    S.reportPhone = S.authPhone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
                    setTimeout(() => {
                        ov.remove();
                        onSuccess();
                    }, 500);
                })
                .fail((xhr) => {
                    ov.remove();
                    showToast(xhr && xhr.status === 429 ? '요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요.' : '인증 확인 중 오류가 발생했습니다.');
                });
        });
    }

    // 소명/본인아님 진입 시 본인인증을 바텀시트로 — 등록안내(auth_first) 위에 오버레이.
    //   인증 성공 → BS 닫고 소명/정정 폼으로 (full 화면 전환 대신). 진입마다 인증상태 초기화.
    function openAuthSheet() {
        S.authSent = false; S.authCode = '';
        if (window._authTimer) clearInterval(window._authTimer);
        showOv('본인 인증', rAuthFormInner(), (sheet) => {
            bindAuthHandlers(() => { sheet.remove(); authSuccessGo(); });
        });
    }

    return { authSuccessGo, bindAuthHandlers, openAuthSheet };
}
